module.exports = __webpack_public_path__ + "static/fonts/iconfont.08d00ff.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.ttf?t=1551407126619
// module id = FS4G
// module chunks = 212